import type { Context } from 'react';
import { createContext } from 'react';

import { type PreloadPriority } from '../lazy/types';

export type EventInfo = {
	identifier: string;
	name?: string;
};

type Profiler = {
	onLoadComplete(info: EventInfo): void;
	onLoadStart(info: EventInfo): void;
	onPreload(moduleId: string, priority?: PreloadPriority): void;
	placeholderFallBackMounted(id: string, name?: string, lazyWait?: boolean): void;
	placeholderFallBackUnmounted(id: string, name?: string, lazyWait?: boolean): void;
};

export type ProfilerContextType = {
	current: Profiler | null;
};

export const GlobalReactLooselyLazyProfiler: ProfilerContextType = {
	current: null,
};

export const ProfilerContext: Context<ProfilerContextType> = createContext<ProfilerContextType>(
	GlobalReactLooselyLazyProfiler,
);
